import { 
    START_LOADING,
    STOP_LOADING,
    START_VALIDATE_TAGS,
    ADD_TAG_ERROR,
    SET_LOCK_TAB_IR,
    SET_UNLOCK_TAB_IR,
    SET_LOCK_TAB_PO,
    SET_UNLOCK_TAB_PO,
    CLEAR_STATUS_TAB,
  }  from "../actions/actionTypes";

  const initialState = {
      isLoading:false,
      isLockTabIR:false,
      isLockTabPO:false,
      isLockTabGR:false,
      isLockTabMR:false,
      mode:"",   // 'view' | '' ค่าว่าง 
      tagErrors:[]
   }

  function AppRedux(state = initialState, action) {
    switch (action.type) {
      case START_LOADING:
        return{
            ...state,
            isLoading:true
        }
      case STOP_LOADING:{
        return{
          ...state,
          isLoading:false
        }
      }
      case START_VALIDATE_TAGS:
        return {
          ...state,
          tagErrors:[]
        }
       case ADD_TAG_ERROR:{
        var tag=action.payload
        var any=state.tagErrors && state.tagErrors.find(f=>f.tagId===tag.tagId)
        if(!any){
          state.tagErrors.push(tag)
        }

           return{
               ...state
           }
          }
        case SET_LOCK_TAB_IR:{
          return{
            ...state,
            isLockTabIR:true
          }
        }
        case SET_UNLOCK_TAB_IR:{
          return{
            ...state,
            isLockTabIR:false
          }
        }
        case CLEAR_STATUS_TAB:{
          return{
            ...state,
            isLockTabPO:false,
            isLockTabIR:false
          }
        }
        case SET_LOCK_TAB_PO:{
          return{
            ...state,
            isLockTabPO:true
          }
        }
        case SET_UNLOCK_TAB_PO:{
          return{
            ...state,
            isLockTabPO:false
          }
        }
      default:
        return state
    }
  }
  
  export default AppRedux;